import { useEffect, useState } from "react";
import { useGetAllCashDetailsEmailMutation, useGetOutlookCredentialsQuery } from "../../../../store/google-reservations/googleReservationsApi";
import { useGetCurrentAuthUrlQuery } from "../../../../store/reservations/reservationsApi";
import { IToast } from "../../../../interfaces/components/IToast";
import Button from "../../../../shared/button";
import Toast from "../../../../shared/toast";

interface IRunEmails {
    setResponse: any;
}

const RunEmailsToCheck = ({
    setResponse
}: IRunEmails) => {
    const [showToast, setShowToast] = useState<IToast | null>()
    const [errorForInvoiceEmails, setErrorForInvoiceEmails] = useState<string>();
    const { data: authUrl } = useGetCurrentAuthUrlQuery({});
    const { data: outlookCredentials } = useGetOutlookCredentialsQuery();
    const [getAllCashDetailsEmail, { isLoading, data, error }] = useGetAllCashDetailsEmailMutation();

    const handleGetCashEmails = async () => {
        try {
            const { accessToken, refreshToken } = outlookCredentials || {};
            localStorage.setItem("googleAccessToken", accessToken || "");
            localStorage.setItem("googleRefreshToken", refreshToken || "");
            setErrorForInvoiceEmails(undefined)
            if (accessToken) {
                const res: any = await getAllCashDetailsEmail(accessToken || "").unwrap();
                setResponse(res?.data)
            } else {
                window.location.assign(authUrl.authUrl);
            }
        } catch (err: any) {
            setShowToast({ type: 'error', message: `${err?.data?.message}` })
        }
    };

    const errorObj = error as { data: { message: string } };
    return (
        <>
            <Button
                label={'Run Email Check Agent'}
                secondLoading={isLoading}
                className={`${isLoading ? 'btn-primary-rounded-less-disable' : 'btn-primary-rounded-less'} mr-4 !flex !flex-row !justify-center !items-center`}
                onClickButton={handleGetCashEmails}
            />
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </>
    );
};

export default RunEmailsToCheck;
